import { render, staticRenderFns } from "./abreviatura.vue?vue&type=template&id=15fb1e2d"
import script from "./abreviatura.vue?vue&type=script&lang=js"
export * from "./abreviatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports